import {
  QBox,
  QFormControl,
  QSelect,
  QSelectPlaceholder,
  QText,
  useCurrentUser,
} from '@qualio/ui-components';
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DocumentAccount } from '../../../api/model/document';

type AccountFilterFieldProps = {
  name: string;
  dataCy: string;
  parentCompanyName: string;
};

export const AccountFilterField = ({
  name,
  dataCy,
  parentCompanyName,
}: AccountFilterFieldProps) => {
  const { t } = useTranslation();
  const { companyName } = useCurrentUser();

  const accountOptions = useMemo(
    () => [
      { value: DocumentAccount.Own, label: companyName },
      { value: DocumentAccount.Parent, label: parentCompanyName },
    ],
    [companyName, parentCompanyName],
  );

  return (
    <QFormControl label={t('labels.account')}>
      <Controller
        name={name}
        render={({ field: { onChange, value, ...field } }) => (
          <QBox data-cy={dataCy}>
            <QSelect
              {...field}
              options={accountOptions}
              value={value ?? null}
              onChange={(item) => onChange(item?.value ?? null)}
              isClearable={true}
              clearInputOnSelect={value == null}
            >
              <QSelectPlaceholder>
                <QText>{t('forms.filterByAccount')}</QText>
              </QSelectPlaceholder>
            </QSelect>
          </QBox>
        )}
      />
    </QFormControl>
  );
};
